import { lazy } from 'react';

const CustomRecertification = lazy(() => import('./CustomRecertification'));

export default CustomRecertification;
